<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199.67 199.67">
    <title>thermal</title>
    <g id="Thermal">
      <path
        class="cls-1"
        d="M82.46,101.79v17l41-17.62v17.67l40-17.7v80.76c-.8,0-1.58.13-2.36.13q-41.69,0-83.39,0c-1.91,0-2.66-.55-2.75-2.43-.4-9-.87-18.06-1.32-27.09q-1-20.09-2-40.19c0-.3,0-.59,0-.89-.25-5.26-.06-5.56,4.9-7.48C78.34,103.3,80.2,102.63,82.46,101.79Zm41.1,46.09h24.16V137.15H123.57Zm-12.63-10.66H86.65v10.66h24.29ZM37.88,182h34L66.49,61.77H43.69ZM68.11,42.14c3-.18,6.08-.2,9.1-.48,8.51-.77,15.33-4.35,19.36-12.21a17.73,17.73,0,0,0,1.76-10.37,62,62,0,0,1-3.82,5.08c-3.39,3.65-7.93,5.08-12.63,6-5.74,1.13-11.53,2-17.26,3.2-6.22,1.29-10.18,5.22-12.06,11.21a14.53,14.53,0,0,0,.85,11.1C54.94,46.61,59.41,42.65,68.11,42.14Zm79.62,105.75V137.15H123.57v10.73ZM86.65,137.22v10.66h24.29V137.22Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "ThermalIcon",
};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: currentColor;
  stroke-miterlimit: 10;
  stroke-width: 10px;
}
</style>
